module.exports = __webpack_public_path__ + "img/asset_mSOL-USDT.6937c5b0.png";